import type { ReactNode } from 'react';
import React, { useState } from 'react';

const defaultValues: IDefaultValues = {
  isProductReviewFiltersDrawerOpen: false,
  toggleProductReviewFiltersDrawer: () => {},
  activeReviewFilterAccordion: '',
  setActiveReviewFilterAccordion: () => {},
};

export const ProductReviewContext = React.createContext(defaultValues);

const ProductReviewProvider = ({ children }: { children: ReactNode }) => {
  const [isProductReviewFiltersDrawerOpen, setIsProductReviewFiltersDrawerOpen] = useState(false);
  const [activeReviewFilterAccordion, setActiveReviewFilterAccordion] = useState('');

  return (
    <ProductReviewContext.Provider
      value={{
        ...defaultValues,
        isProductReviewFiltersDrawerOpen,
        activeReviewFilterAccordion,
        toggleProductReviewFiltersDrawer: setIsProductReviewFiltersDrawerOpen,
        setActiveReviewFilterAccordion,
      }}
    >
      {children}
    </ProductReviewContext.Provider>
  );
};

export default ProductReviewProvider;

interface IDefaultValues {
  isProductReviewFiltersDrawerOpen: boolean;
  toggleProductReviewFiltersDrawer: (newValue: boolean) => void;
  activeReviewFilterAccordion: string;
  setActiveReviewFilterAccordion: (id: string) => void;
}
